import { BaseController } from '~/utils/base-controller';

/**
 * @implements {angular.IController}
 */
export default class GaugeChartSettings extends BaseController {
	// bindings
	widget;

	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	constructor(
		$injector,
	) {
		super($injector);

		this.settings = {
			minValue: 0,
			thresholds: [
				{
					color: [{ kid: 'K_NODE;GREEN', name: 'Vert' }],
					value: 50,
					label: 'Valide',
				},
				{
					color: [{ kid: 'K_NODE;RED', name: 'Rouge' }],
					value: 100,
					label: 'Invalide',
				},
			],
		};
	}

	$onInit() {
		if (this.widget?.options?.data) {
			this.settings = { ...this.widget.options.data };
		}

		this.parent.widgetData = this.settings;
	}

	addLine() {
		const previousLine = this.settings.thresholds[this.settings.thresholds.length - 1];
		this.settings.thresholds.push({
			color: [{ kid: 'K_NODE;GREEN', name: 'Vert' }],
			label: '',
			value: previousLine.value + 10,
		});
	}

	removeLine(index) {
		this.settings.thresholds.splice(index, 1);
	}

	isInvalid(value) {
		return value === null || value === '';
	}

	getErrors() {
		const errors = [];

		if (this.isInvalid(this.settings.minValue)) {
			errors.push('Une valeur minimum est requise');
		}

		if (this.settings.thresholds.length === 0) {
			errors.push('Aucun seuil défini');
		}

		for (const [_index, line] of Object.entries(this.settings.thresholds)) {
			const index = Number.parseInt(_index, 10);
			if (this.isInvalid(line.color)) {
				errors.push(`Une couleur est requise (${index})`);
			}
			if (this.isInvalid(line.value)) {
				errors.push(`Un seuil est requis (${index})`);
			}
			if (this.isInvalid(line.label)) {
				errors.push(`Un nom est requis (${index})`);
			}

			const previousValue = index > 0 ? this.settings.thresholds[index - 1].value : this.settings.minValue;
			if (line.value <= previousValue) {
				errors.push(`${line.value} doit être plus grand que ${previousValue} (${index})`);
			}
		}

		this.parent.isValid = errors.length === 0;

		return errors;
	}

	getErrorsAsString() {
		return this.getErrors().join(', ');
	}

	canBeNull(value) {
		return value ?? 'Ø';
	}
}
